import React from "react";
import { Form, Button, Col, Row } from "antd";
import { CheckCircleFilled, CloseCircleOutlined } from "@ant-design/icons";
import { isEmpty } from "lodash";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import { useSelector } from "react-redux";
import { setCountryCookie } from "../../../utils/helper";

const RoutePhoneForm = ({ driverId, phone, onSubmit, onCancel, countryCodeInit }) => {
  const [form] = Form.useForm();
  const user = useSelector(state => state.auth.user);

  const handleOnFinish = values => {
    onSubmit({
      driver: driverId,
      phone: !isEmpty(values.phone) ? `${values.phone.includes("+") ? "" : "+"}${values.phone}` : null,
    });
  };

  return (
    <Form form={form} initialValues={{ phone }} onFinish={handleOnFinish}>
      <Row align="middle">
        <Col>
          <Form.Item name="phone" rules={[{ required: true, message: "Required" }]} style={{ margin: 0 }}>
            <PhoneInput
              country={countryCodeInit}
              enableSearch
              disableSearchIcon
              countryCodeEditable
              onChange={(value, country) => {
                setCountryCookie(value, country, user);
              }}
            />
          </Form.Item>
        </Col>
        <Col>
          <Button htmlType="submit" icon={<CheckCircleFilled style={{ color: "#00C853" }} />} className="btn-submit" />
          <Button
            icon={<CloseCircleOutlined style={{ color: "#888888" }} />}
            onClick={onCancel}
            className="btn-cancel"
            style={{ marginLeft: "-8px" }}
          />
        </Col>
      </Row>
    </Form>
  );
};

export default RoutePhoneForm;
